import React, { Fragment, useEffect, useState } from 'react';
import {
  useAcceptTermsAndConditions,
  useGetPublicTermsAndConditions,
} from '../hooks/termsAndConditions';
import { useLocation, useNavigate } from 'react-router-dom';

import Button from './common/Button';
import ErrorBanner from './common/ErrorBanner';
import Header from './common/Header';
import Loader from './common/Loader';
import ModalDeclineTermsAndCondition from './modals/ModalDeclineTermsAndCondition';
import Skeleton from 'react-loading-skeleton';
import { routes } from '../routes';
import { useAuth } from '../hooks/auth';
import { useTranslation } from 'react-i18next';

export default function TermsAndConditions() {
  const { i18n, t } = useTranslation();
  const { state } = useLocation();
  const navigate = useNavigate();
  const [IsOpenModalDecline, setIsOpenModalDecline] = useState(false);

  const {
    isFetching,
    data: termsAndConditions,
    isError: isFetchPublicTermsAndConditionsError,
    refetch: fetchPublicTermsAndConditions,
  } = useGetPublicTermsAndConditions();

  const {
    isPending: isPendingAcceptTermsAndConditions,
    isError: isErrorAcceptTermsAndConditions,
    mutateAsync: acceptTermsAndConditions,
  } = useAcceptTermsAndConditions();

  const { user } = useAuth();

  useEffect(() => {
    if (!state?.termsAndConditions) fetchPublicTermsAndConditions();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleClickAccept = () => {
    if (!user) {
      window.location.replace(
        `${process.env.REACT_APP_AZURE_B2C_SING_UP_URL}&ui_locales=${i18n.language}`!
      );
    } else {
      acceptTermsAndConditions().then(() => {
        navigate(`${routes.OVERVIEW.path}${window.location.search}`);
      });
    }
  };

  const handleClickRefused = () => {
    setIsOpenModalDecline(true);
  };

  const handClickOnActionModalDecline = () => {
    setIsOpenModalDecline(false);
  };

  return (
    <Fragment>
      <Header />
      {(isFetchPublicTermsAndConditionsError || isErrorAcceptTermsAndConditions) && <ErrorBanner />}
      <main>
        <section className="terms-and-conditions container d-flex justify-content-center">
          <div className="card terms-and-conditions__card">
            {(isFetching ||
              isFetchPublicTermsAndConditionsError ||
              isErrorAcceptTermsAndConditions) && (
              <div>
                <Skeleton count={1} height={25} width="50%" className="mb-4" />
                <Skeleton count={1} />
                <Skeleton count={1} width="70%" />
                <Skeleton count={1} width="90%" className="mb-4" />
                <Skeleton count={1} />
                <Skeleton count={1} />
                <Skeleton count={1} />
                <Skeleton count={1} className="mb-4" />
                <Skeleton count={1} />
                <Skeleton count={1} width="70%" />
                <Skeleton count={1} width="90%" />
              </div>
            )}
            {(termsAndConditions || state?.termsAndConditions) &&
              !isFetchPublicTermsAndConditionsError && (
                <Fragment>
                  <div
                    className="mb-3"
                    data-test-id="terms-and-conditions-content"
                    dangerouslySetInnerHTML={{
                      __html:
                        (state?.termsAndConditions
                          ? decodeURIComponent(state?.termsAndConditions)
                          : null) ?? termsAndConditions!.data,
                    }}
                  />
                  {(state ? state.hasFooter : true) && (
                    <div
                      className="terms-and-conditions__footer row"
                      data-test-id="terms-and-conditions-footer"
                    >
                      <div className="col-12 col-lg-6 mb-3">
                        <Button
                          isDisabled={isPendingAcceptTermsAndConditions}
                          prefix={isPendingAcceptTermsAndConditions ? <Loader /> : null}
                          className="btn btn--primary"
                          onClick={handleClickAccept}
                        >
                          {t('common.accepted')}
                        </Button>
                      </div>
                      <div className="col-12 col-lg-6">
                        <Button className="btn btn--secondary" onClick={handleClickRefused}>
                          {t('common.refused')}
                        </Button>
                      </div>
                    </div>
                  )}
                </Fragment>
              )}
          </div>
          <div role="img" className="terms-and-conditions__banner" aria-label="Illustration" />
        </section>
        <ModalDeclineTermsAndCondition
          isOpen={IsOpenModalDecline}
          onClickAction={handClickOnActionModalDecline}
        />
      </main>
    </Fragment>
  );
}
